import React, { useEffect, useState } from "react";
import "./YourOrders.css";
import OrderSuccessful from "../Order/OrderSuccessful";
import { useRecoilState } from "recoil";
import { orderSuccessfulProvider } from "../../Providers/OrderSuccessfulProvider";
import { useDispatch, useSelector } from "react-redux";
import { formatPrice } from "../../utils/helpers";
import { fetchOrderProductsAsync, selectOrders } from "../../store/orderSlice";
import { IMAGE_URL1 } from "../../utils/apiURL";
import { Tag } from "antd"; // Importation du composant Tag d'Ant Design

const YourOrders = () => {
  const dispatch = useDispatch();
  const orders = useSelector(selectOrders); // Récupérer les commandes complètes
  const [selectedOrderId, setSelectedOrderId] = useState(0);
  const [orderSuccessCont, setOrderSuccessCont] = useRecoilState(
    orderSuccessfulProvider
  );

  const transformerEnCode = (orderId) => {
    let deuxChiffres = String(orderId).padStart(3, "0").slice(0, 3);
    let lettres = "";
    for (let i = 0; i < 3; i++) {
      lettres += String.fromCharCode(65 + ((orderId + i) % 26)); // 65 est le code ASCII pour 'A'
    }
    return deuxChiffres + lettres;
  };

  useEffect(() => {
    dispatch(fetchOrderProductsAsync());
  }, [dispatch]);

  const getOrderStatus = (status) => {
    switch (status) {
      case "1":
        return { label: "On hold", color: "#616BFA" };
      case "2":
        return { label: "Accepted", color: "#F85515" };
      case "3":
        return { label: "Confirmed", color: "#079905" };
      default:
        return { label: "Denied", color: "#FC1C54" };
    }
  };

  const handleViewInvoice = (orderId) => {
    setSelectedOrderId(orderId);
    // Vous pouvez maintenant envoyer l'ID de la commande à un autre composant ou service
    console.log("View invoice for order ID:", orderId);
  };

  return (
    <div className="yourorders">
      <h1 className="mainhead1">Your Orders</h1>
      {orderSuccessCont && (
        <OrderSuccessful
          orderid={selectedOrderId}
          message={`Order ID: #${transformerEnCode(selectedOrderId)}`}
        />
      )}
      <table className="yourorderstable">
        <thead>
          <tr>
            <th scope="col">Image</th>
            <th scope="col">Name</th>
            <th scope="col">Quantity</th>
            <th scope="col">Total</th>
            <th scope="col">Status</th>
            {/* <th scope="col">Invoice</th> */}
          </tr>
        </thead>
        <tbody>
          {orders.length > 0 ? (
            orders.map((order) => (
              <React.Fragment key={order.order_id}>
                {/* Affichage des informations de la commande */}
                <tr>
                  <td colSpan="5" style={{ fontWeight: "bold", fontSize: "18px" }}>
                    Order #{transformerEnCode(order.order_id)}
                    {/* - Status:{" "}
                    {order.status === "1"
                      ? "On hold"
                      : order.status === "2"
                      ? "Confirmed"
                      : order.status === "3"
                      ? "Denied"
                      : "Status unknown"} */}
                  </td>
                </tr>

                {/* Affichage des produits de la commande */}
                {order.products.map((product) => (
                  <tr key={product.product_id}>
                    <td data-label="Product Image">
                      <img
                        src={`${IMAGE_URL1}${product.product_images1}`}
                        alt={`Product ${product.product_id}`}
                        style={{
                          width: "50px",
                          height: "50px",
                          objectFit: "cover",
                        }}
                      />
                    </td>
                    <td data-label="Product Name">
                      {product.product_name || "No name"}
                    </td>
                    <td data-label="Product Quantity">{product.quantity}</td>
                    <td data-label="Total Price">
                      {formatPrice(product.total)}
                    </td>
                    <td data-label="Status">
                      <Tag color={getOrderStatus(order.status).color}>
                        {getOrderStatus(order.status).label}
                      </Tag>
                    </td>
                    {/* <td data-label="Invoice">
                      <button
                        className="mainbutton1"
                        onClick={() => {
                          setSelectedOrderId(product.product_id);
                          setOrderSuccessCont(true);
                        }}
                      >
                        View
                      </button>
                    </td> */}
                  </tr>
                ))}
              </React.Fragment>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">
                No orders found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default YourOrders;

{
  /* <td data-label="Invoice">
                    <button
                      className="mainbutton1"
                      onClick={() => {
                        setSelectedOrderId(item.product_id);
                        setOrderSuccessCont(true);
                      }}
                    >
                      View
                    </button>
                  </td> */
}

// import React, { useEffect, useState } from "react";
// import "./YourOrders.css";
// import OrderSuccessful from "../Order/OrderSuccessful";
// import { useRecoilState } from "recoil";
// import { orderSuccessfulProvider } from "../../Providers/OrderSuccessfulProvider";
// import { useDispatch, useSelector } from "react-redux";
// import { formatPrice } from "../../utils/helpers";
// import {
//   fetchOrderProductsAsync,
//   selectOrderProducts,
//   selectOrderStatus,
// } from "../../store/orderSlice";
// import { IMAGE_URL1 } from "../../utils/apiURL";

// const YourOrders = () => {
//   const dispatch = useDispatch();
//   const orders = useSelector(selectOrderProducts) || []; // S'assurer que orders est un tableau vide par défaut
//   const status = useSelector(selectOrderStatus); // Récupérer le statut global
//   const [selectedOrderId, setSelectedOrderId] = useState(0);
//   const [orderSuccessCont, setOrderSuccessCont] = useRecoilState(orderSuccessfulProvider);

//   const transformerEnCode = (orderId) => {
//     let deuxChiffres = String(orderId).padStart(3, '0').slice(0, 3);
//     let lettres = '';
//     for (let i = 0; i < 3; i++) {
//       lettres += String.fromCharCode(65 + (orderId + i) % 26); // 65 est le code ASCII pour 'A'
//     }
//     return deuxChiffres + lettres;
//   };

//   useEffect(() => {
//     // Appel de l'action pour récupérer les commandes
//     console.log('Orders received:', orders);  // Vérifiez que les commandes sont bien récupérées
//     dispatch(fetchOrderProductsAsync());
//   }, [dispatch]);

//   // Regrouper les produits par order_id
//   const groupedOrders = orders.reduce((acc, item) => {
//     // Vérifie si la commande avec le même order_id existe déjà dans le tableau
//     const existingOrder = acc.find(order => order.order_id === item.order_id);

//     if (existingOrder) {
//       // Si la commande existe déjà, ajoute simplement le produit
//       existingOrder.products.push(item);
//     } else {
//       // Si la commande n'existe pas, crée un nouvel objet pour cette commande
//       acc.push({
//         order_id: item.order_id,
//         total: item.total,
//         status: item.status,
//         products: [item], // Ajoute le produit dans un tableau
//       });
//     }

//     return acc; // Retourne le tableau des commandes groupées
//   }, []);

//   console.log('Grouped Ordersss:', groupedOrders);  // Affiche les commandes regroupées

//   return (
//     <div className="yourorders">
//       <h1 className="mainhead1">Your Orders</h1>
//       {orderSuccessCont && (
//         <OrderSuccessful
//           orderid={selectedOrderId}
//           message={`Order ID: #${transformerEnCode(selectedOrderId)}`}
//         />
//       )}
//       <table className="yourorderstable">
//         <thead>
//           <tr>
//             <th scope="col">Order ID</th>
//             <th scope="col">Image</th>
//             <th scope="col">Name</th>
//             <th scope="col">Quantity</th>
//             <th scope="col">Total</th>
//             <th scope="col">Status</th>
//             <th scope="col">Invoice</th>
//           </tr>
//         </thead>
//         <tbody>
//           {groupedOrders.length > 0 ? (
//             <>
//               {groupedOrders.map((order) => (
//                 <React.Fragment key={order.order_id}>
//                   {order.products.map((item, index) => (
//                     <tr key={`${order.order_id}-${item.product_id}`}>
//                       {/* Si c'est la première ligne pour un order_id, afficher l'order_id */}
//                       {index === 0 && (
//                         <td rowSpan={order.products.length} data-label="OrderID">
//                           {transformerEnCode(order.order_id)}
//                         </td>
//                       )}
//                       <td data-label="Product Image">
//                         <img
//                           src={`${IMAGE_URL1}${item.product_images1 || 'default.png'}`}
//                           alt={`Product ${item.product_id}`}
//                           style={{
//                             width: "50px",
//                             height: "50px",
//                             objectFit: "cover",
//                           }}
//                         />
//                       </td>
//                       <td data-label="Product Name">{item.product_name || "Unknown Product"}</td>
//                       <td data-label="Product Quantity">{item.quantity}</td>
//                       <td data-label="Total Price">{formatPrice(item.total)}</td>
//                       <td data-label="Status">
//                         {order.status === "1" ? "On hold" :
//                          order.status === "2" ? "Confirmed" :
//                          order.status === "3" ? "Denied" : "Status unknown"}
//                       </td>
//                       <td data-label="Invoice">
//                         <button
//                           className="mainbutton1"
//                           onClick={() => {
//                             setSelectedOrderId(order.order_id);
//                             setOrderSuccessCont(true);
//                           }}
//                         >
//                           View
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </React.Fragment>
//               ))}
//             </>
//           ) : (
//             <tr>
//               <td colSpan="7" className="text-center">
//                 No orders found.
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default YourOrders;
